import { createSlice } from '@reduxjs/toolkit';
import has from 'lodash/has';
import unset from 'lodash/unset';

import { BULK_DELETE_SBAT_GROUP_MODAL_STAGES } from '@classCreation/data/bulkDeleteSbatGroupModalStages';
import { BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES } from '@classCreation/data/bulkRemoveSuperBatchesModalStages';

const initialState = {
  selectedSbatGroups: {},
  communications: {},
  addSuperBatchesModalState: false,
  removeSuperBatchesModalStage: BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.notOpen,
  updateInstructorsModalState: false,
  deleteSbatGroupsModalStage: BULK_DELETE_SBAT_GROUP_MODAL_STAGES.notOpen,
  reason: null,
  bulkDeleteErrorMessage: null,
};

export const sbatGroupBulkUpdate = createSlice({
  name: 'sbatGroupBulkUpdate',
  initialState,
  reducers: {
    setSelectedSbatGroups: (state, action) => {
      if (has(state.selectedSbatGroups, action.payload.id)) {
        unset(state.selectedSbatGroups, action.payload.id);
      } else {
        state.selectedSbatGroups[action.payload.id] = action.payload;
      }
    },
    setBulkSelectedSbatGroups: (state, action) => {
      state.selectedSbatGroups = action.payload;
    },
    setSbatGroupBulkUpdateCommunications: (state, action) => {
      state.communications[action.payload.channel] = action.payload.enabled;
    },
    setAddSuperBatchesModalState: (state, action) => {
      state.addSuperBatchesModalState = action.payload;
    },
    setRemoveSuperBatchesModalStage: (state, action) => {
      state.removeSuperBatchesModalStage = action.payload;
    },
    setUpdateInstructorsModalState: (state, action) => {
      state.updateInstructorsModalState = action.payload;
    },
    setDeleteSbatGroupsModalStage: (state, action) => {
      state.deleteSbatGroupsModalStage = action.payload;
    },
    setDeleteSbatGroupsErrorMessage: (state, action) => {
      state.bulkDeleteErrorMessage = action.payload;
    },
    setSbatGroupBulkUpdateReason: (state, action) => {
      state.reason = action.payload;
    },
    resetSbatGroupBulkUpdate: (state) => {
      state.selectedSbatGroups = {};
      state.communications = {};
      state.addSuperBatchesModalState = false;
      state.updateInstructorsModalState = false;
      state.deleteSbatGroupsModalStage =
        BULK_DELETE_SBAT_GROUP_MODAL_STAGES.notOpen;
      state.reason = null;
    },
  },
});

export const {
  setSelectedSbatGroups,
  setBulkSelectedSbatGroups,
  setSbatGroupBulkUpdateCommunications,
  setAddSuperBatchesModalState,
  setRemoveSuperBatchesModalStage,
  setUpdateInstructorsModalState,
  setDeleteSbatGroupsModalStage,
  setSbatGroupBulkUpdateReason,
  setDeleteSbatGroupsErrorMessage,
  resetSbatGroupBulkUpdate,
} = sbatGroupBulkUpdate.actions;

export default sbatGroupBulkUpdate.reducer;
